export enum EditorMode {
  Info = 'info',
  InfoEdit = 'infoEdit',
  InfoEditState = 'infoEditState',
  Editor = 'editor',
  Printer = 'printer',
  Summary = 'summary',
  Preview = 'preview',
  Generation = 'generation',
  Share = 'share',
  Versions = 'versions',
  Admin = 'admin',
  AdminEdit = 'adminEdit',
}
